/* The Brilian — Dawn product-card enhancers + PDP Trendyol button.
   Cards: round '3 AL 2 ÖDE' sticker on the image + below-content '3 Al 2 Öde' badge + 'Satın Al' (product page link) + Trendyol.
   Injects ONLY into the static below-image content (never the absolute image overlay). Homepage rail is native and skipped. */
(function () {
  var TRENDYOL = 'https://www.trendyol.com/magaza/the-brilian-m-1266957?sst=0&channelId=1';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function belowContent(cw) {
    // the static content area under the image = direct child .card__content of .card
    var content = cw.querySelector('.card > .card__content');
    if (!content) {
      var h = cw.querySelector('.card__heading.h5') || cw.querySelector('.card__heading');
      content = h ? h.closest('.card__content') : null;
    }
    if (content && getComputedStyle(content).position === 'absolute') return null; // never the overlay
    return content;
  }

  function enhanceCards(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper');
    cards.forEach(function (cw) {
      var link = cw.querySelector('.card__heading a') || cw.querySelector('a.full-unstyled-link');
      var url = link ? link.getAttribute('href') : null;
      if (!url || url.indexOf('/products/') === -1) return;

      if (!cw.querySelector('.br3al2-sticker')) {
        cw.appendChild(el('span', 'br3al2-sticker', '3 AL 2 ÖDE'));
      }

      var content = belowContent(cw);
      if (!content || content.querySelector('.br3al2-cardactions')) return;

      var badge = el('div', 'br3al2-badge');
      badge.appendChild(el('strong', null, '3 Al 2 Öde'));
      badge.appendChild(document.createTextNode(' · sepette otomatik'));

      var wrap = el('div', 'br3al2-cardactions');
      var buy = el('a', 'br3al2-buy', 'Satın Al');
      buy.href = url;
      var tr = el('a', 'br3al2-trendyol', 'Trendyol');
      tr.href = TRENDYOL; tr.target = '_blank'; tr.rel = 'noopener nofollow';
      wrap.appendChild(buy);
      wrap.appendChild(tr);

      var info = content.querySelector('.card__information');
      if (info && info.parentNode === content) {
        info.insertAdjacentElement('afterend', badge);
        badge.insertAdjacentElement('afterend', wrap);
      } else {
        content.appendChild(badge);
        content.appendChild(wrap);
      }
    });
  }

  function enhancePDP() {
    var btns = document.querySelector('.product-form__buttons');
    if (btns && !btns.querySelector('.br3al2-pdp-trendyol')) {
      var a = el('a', 'br3al2-pdp-trendyol', "Trendyol'da İncele");
      a.href = TRENDYOL; a.target = '_blank'; a.rel = 'noopener nofollow';
      btns.appendChild(a);
    }
  }

  function enhance(scope) {
    enhanceCards(scope);
    enhancePDP();
  }

  function init() {
    enhance(document);
    var target = document.querySelector('main') || document.body;
    if (target && window.MutationObserver) {
      var scheduled = false;
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && (t.closest('.br3al2-cardactions') || t.closest('.br3al2-sticker') || t.closest('.br3al2-badge'))) continue;
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function () { scheduled = false; enhance(document); });
          return;
        }
      });
      obs.observe(target, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { enhance(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();